import { ReactNode } from "react";
import { atom } from "recoil";

export type ModalStateType = {
  type: "login" | "guide" | "";
  // 문자열뿐 아니라 인라인 아이콘/JSX 삽입이 가능하도록 ReactNode 허용.
  // 기존 호출부의 `string` 전달은 ReactNode 부분 집합이라 그대로 동작.
  message: ReactNode;
  isOpen: boolean;
};

export const modalState = atom<ModalStateType>({
  key: "modalState",
  default: {
    type: "",
    message: "",
    isOpen: false,
  },
});
